import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "tags", "dropdown"]

  connect() {
    this.renderTags()
  }

  add() {
    const value = this.dropdownTarget.value
    if (!value) return

    const option = this.selectTarget.querySelector(`option[value="${CSS.escape(value)}"]`)
    if (option) option.selected = true

    this.dropdownTarget.value = ""
    this.renderTags()
  }

  remove(event) {
    const value = event.currentTarget.dataset.value
    const option = this.selectTarget.querySelector(`option[value="${CSS.escape(value)}"]`)
    if (option) option.selected = false
    this.renderTags()
  }

  renderTags() {
    const selected = Array.from(this.selectTarget.selectedOptions).map(o => o.value)
    this.tagsTarget.innerHTML = selected.map(value => `
      <span class="inline-flex items-center gap-1 bg-gray-100 border border-gray-300 text-gray-700 text-sm px-2 py-1 rounded-full">
        ${this.escapeHtml(value)}
        <button type="button" class="text-gray-400 hover:text-red-500 leading-none" data-value="${this.escapeAttr(value)}" data-action="click->admin--multi-select-tags#remove">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
          </svg>
        </button>
      </span>
    `).join("")
  }

  escapeHtml(str) {
    return str.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;")
  }

  escapeAttr(str) {
    return str.replace(/"/g, "&quot;")
  }
}
